import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '@components'
import { useLanguage } from '@context'
import { Theme } from '@theme'
import { useUpdateEvent } from '@hooks'
import { OptionChips } from './OptionChips'

/**
 * On/off per event for the automatic J-1 / day-of reminders. On by default;
 * the CRM emailing quota is untouched by this (separate accounting server-side).
 */
export function RemindersToggle({
  eventId,
  remindersEnabled,
}: {
  eventId: string
  remindersEnabled: boolean
}) {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyles(theme)
  const update = useUpdateEvent()

  const value = remindersEnabled ? 'on' : 'off'

  return (
    <View style={styles.panel}>
      <OptionChips
        testID="event-reminders-toggle"
        label={t('events.manage.reminders.title')}
        options={[
          { value: 'on', label: t('events.manage.reminders.enabled') },
          { value: 'off', label: t('events.manage.reminders.disabled') },
        ]}
        value={value}
        // Tapping the selected chip would clear it: a choice is always kept here.
        onChange={(v) => v && update.mutate({ eventId, values: { remindersEnabled: v === 'on' } })}
      />
      <Text type="bodyExtraSmall" color={theme.colors.greyBlue}>
        {t('events.manage.reminders.hint')}
      </Text>
    </View>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    panel: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.border.jumbo,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      padding: theme.spacing.xl,
      gap: theme.spacing.md,
    },
  })
